import React, { useEffect, useState } from "react";
import { ChevronDown, ChevronUp } from "react-bootstrap-icons";
import Layout from "../components/Layout";
import MySpinner from '../components/MySpinner';
import { useParams } from "react-router-dom";
import { getProfileUpdateRequestAsync, updateProfileUpdateRequestAsync } from "../services/employeeService";
import { formatDate } from "../utilities/formatDate";
const EmployeeRequests = () => {
const { empId } = useParams();
const [loading,setLoading] =useState(false);
const [error,setError] =useState("");
const [requests,setRequests] =useState([]);
const [status,setStatus] =useState("");
 
  // Toggle card expansion
  const toggleDetails = async(requestId,isEmpRead) => {
    if(isEmpRead === true) {
            setRequests((prevRequests) =>
                prevRequests.map((req) =>
                  req.requestId === requestId ? { ...req, expanded: !req.expanded } : req
                )
              );
    }else{
        setLoading(true)
        try {
            const result = await updateProfileUpdateRequestAsync(requestId);
            if(result === true){
                setRequests((prevRequests) =>
                    prevRequests.map((req) =>
                      req.requestId === requestId ? { ...req, expanded: !req.expanded } : req
                    )
                  );
            }
        } catch (error) {
            setError(error.message  || "حدث خطأاثناء جلب تفاصل العملية");
        }finally{
            setLoading(false)
        }
     
    }
   
  };
  
  const getProfileUpdateRequests=async()=>{
    setLoading(true)
    try {
        const results = await getProfileUpdateRequestAsync(empId);
        setRequests(results)
    } catch (error) {
        setError(error.message || "حدث خطأ اثناء جلب البيانات");
    }finally{
        setLoading(false)
    }
  }
  useEffect(()=>{
    getProfileUpdateRequests();
  },[]);
  
  return (
    <Layout>
        {loading && <MySpinner/>}
      <div className="container py-4">
        <h2 className="text-center mb-4 page-title">📋 طلباتي</h2>

        <div className="d-flex flex-column align-items-center ">
          {Array.isArray(requests) && requests.length > 0 ?
             (requests.map((request) => (
            <div
              key={request.requestId}
              className="empRequests-card shadow-sm p-3 mb-3 rounded primary-bg"
              style={{ width: "80%"}}
            >
              <div
                className="d-flex justify-content-between align-items-center"
                onClick={request.status !== "pending" ? () => toggleDetails(request.requestId,request.isEmpRead) : null}
                style={request.status !== "pending" ? { cursor: "pointer" } : null}
              >
                <div>
                    {request.status === "pending" ? 
                  <span className="badge secondary-bg">
                  قيد الانتظار
                </span>
                :
                <span className={`badge ${request.isEmpRead ? "bg-secondary" : "bg-success"}`}>
                {request.isEmpRead ? "مقروء" : "جديد"}
              </span>    
                }
                 
                  <h5 className="mb-1">
                    {request.requestTitle} #{request.referenceNumber}
                  </h5>
                  <strong className="text-muted bold ">{formatDate(request.createdAt)}</strong>
                </div>
                {
                     request.status !== "pending" ?
                        <button className="btn secondary-bg text-white">
                          {request.expanded ? <ChevronUp /> : <ChevronDown />}
                        </button>
                :null}
              </div>

              {/* Expanded Section */}
              {request.expanded && (
                <div className="empRequests-details-section mt-3 p-3 rounded secondary-bg">
                  {request.status === "rejected" ? (
                    <p className="">
                      ❌ الطلب مرفوض: {request.adminReplyMessage}
                    </p>
                  ) : (
                    <p >
                      ✅ {request.adminReplyMessage}
                    </p>
                  )}
                </div>
              )}
            </div>
          )) )
          : 
          error ?
          <div className="alert alert-warning">{error}</div>
          : <div>لايوجد لديك طلبات</div>

          }
        </div>
      </div>
    </Layout>
  );
};

export default EmployeeRequests;
